/**
 * Synthetic LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SyntheticSecondLegConditionDto {
  id?: number;
  minTradeQty?: number;
  positionGoal?: number;
  firstExtraPairId?: number;
  firstExtraPairMaxSpread?: number;
  secondExtraPairId?: number;
  secondExtraPairMaxSpread?: number;
  widenSpread?: number;
  noMdFromLpMode?: boolean;
  forbiddenMdSending?: boolean;
  currentPosition?: number;
  invertedPair?: boolean;
}
